import { z } from "zod";
import { passwordSchema } from "@cartz/auth/client";
import { CompanyTypeSchema, ShopTypeEnumSchema } from "@jurni/schemas";

export const signinSchema = z.object({
  email: z.email({ message: "Invalid email address." }),
  password: z.string(),
});

export const signupSchema = z.object({
  firstName: z.string().min(1, {
    message: "First name is required.",
  }),
  lastName: z.string().min(1, {
    message: "Last name is required.",
  }),
  email: z.email({ message: "Invalid email address." }),
  password: passwordSchema,
  termsAccepted: z.boolean().refine((val) => val === true, {
    message: "You must accept the Terms of Service.",
  }),
});

export const forgotPasswordSchema = z.object({
  email: z.email({ message: "Invalid email address." }),
});

export const resetPasswordSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: passwordSchema,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export const aboutSchema = z.object({
  companyType: CompanyTypeSchema,
});

export const connectShopSchema = z.object({
  storeConnected: ShopTypeEnumSchema,
});

export const bookDemoSchema = z.object({
  name: z.string().min(1, "Name is required."),
  email: z.email({ message: "Invalid email address." }),
  websiteUrl: z.string().min(1, "Company website is required."),
});
